<template>
  <div class="table-wrapper" :class="[id.indexOf('-small_') !== -1 ? 'table-small-scroll-down' : 'table-fullscreen-scroll-down']">
    <table class="table" :id="this.id + '_table'">
      <tr class="table-row table-row-header">
        <th v-for="col in tableColumns" :key="col.code" @click="clickColumn(col.code)">
          {{ lastSort.columnCode === col.code ? col.title + '&nbsp;&#8593;&#8595;' : col.title }}
          <!-- <span class="sort-button" @click="clickColumn(col.code)">&#8593;&#8595;</span> -->
        </th>
      </tr>
      <tr v-for="(item, itemIndex) in tableData" :key="itemIndex" class="table-row" @click="clickRow(itemIndex, item, $event)">
        <th v-for="(field, fieldIndex) in item" :key="fieldIndex">{{ field }}</th>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'table-chart',
  props: ['graphData', 'id', 'type'],
  data () {
    return {
      tableColumns: [],
      tableData: [],
      lastSort: {
        sort: null,
        columnCode: null
      }
    }
  },
  mounted () {
    let _data = this.createDataTable(this.graphData, true)
    this.tableColumns = _data.columns
    this.tableData = _data.data
  },
  methods: {
    clickColumn (columnCode) {
      if (this.lastSort.columnCode === columnCode) { // если сортируем туже колонку
        if (this.lastSort.sort === 'ASC') {
          this.sortTableDataBy('DESC', columnCode)
          this.lastSort.sort = 'DESC'
        } else {
          this.sortTableDataBy('ASC', columnCode)
          this.lastSort.sort = 'ASC'
        }
      } else { // если сортируем новую колонку
        this.sortTableDataBy('ASC', columnCode)
        this.lastSort.sort = 'ASC'
      }
      this.lastSort.columnCode = columnCode
      let _data = this.createDataTable(this.graphData) // пересоздаем данные
      this.tableColumns = _data.columns
      this.tableData = _data.data
    },

    sortTableDataBy (type, columnCode) {
      let sortVal = type === 'ASC' ? -1 : 1
      this.graphData.data.sort((item1, item2) => {
        if (!isNaN(Number(item1[columnCode])) && !isNaN(Number(item2[columnCode]))) {
          return Number(item1[columnCode]) < Number(item2[columnCode]) ? sortVal : -1 * sortVal
        } else {
          return item1[columnCode] < item2[columnCode] ? sortVal : -1 * sortVal
        }
      })
    },

    clickRow (di, item, e) {
      let _e = {
        dataIndex: di,
        event: {
          event: {
            zrX: e.layerX,
            zrY: e.layerY
          }
        }
      }
      let popup = this.createPopup(_e, this.id)
      let onMapButton = popup.children[0].children[2]
      onMapButton.onclick = e => { this.$eventHub.$emit('tableClick_' + this.id, {dataIndex: di, blockId: this.id}) }
      // let getChildButton = popup.children[0].children[2]
      if (document.body.clientWidth > 768) {
        // console.log(e)
        if (e.path !== undefined && e.path[2] !== undefined) { // хромоподобные
          e.path[2].appendChild(popup)
        } else { // mozilla
          e.originalTarget.appendChild(popup)
        }
      } else {
        document.body.appendChild(popup)
      }
      this.$eventHub.$emit('changeStyleButtonGoChildTable_' + this.id, {dataIndex: di, blockId: this.id})
    },

    createDataTable (graphData, mountedHook) {
      let _allData = {
        columns: null,
        data: null
      }

      let _columns = []
      for (let i = 0; i < graphData.columns.length; i++) {
        _columns.push({
          title: graphData.columns[i].title,
          code: graphData.columns[i].code
        })
      }

      if (mountedHook === true) {
        this.sortTableDataBy('ASC', _columns[0].code)
        this.lastSort.sort = 'ASC'
        this.lastSort.columnCode = _columns[0].code
      }

      let _data = []
      let item = {}
      for (let i = 0; i < graphData.data.length; i++) { // проход по всем данным
        item = {}
        for (let j = 0; j < _columns.length; j++) { // создаем поля в item в соответствии с _columns с пустыми значениями(обуляем имеющиеся)
          item[_columns[j].code] = ''
        }

        for (let j = 0; j < _columns.length; j++) { // заполняем значения в item в соответсвии с порядком следования в _columns
          let key = _columns[j].code
          if (key in graphData.data[i]) { // если поле есть в объекте даты
            item[key] = graphData.data[i][key]
          } else {
            item[key] = ''
          }
        }
        _data.push(item)
      }

      _allData.columns = _columns
      _allData.data = _data

      return _allData
    }
  }
}
</script>

<style scoped>
.table-wrapper {
  padding: 15px;
  padding-top: 0px;
}
.table {
  border-collapse: collapse;
  width: 100%;
  border-spacing: 0;
  margin: auto;
  font-size: 13px;
  position: relative;
}
.table-row {
  background-color: white;
  border-bottom: 1px solid #EBEDEF;
}
.table-row:hover {
  background-color:#EBEDEF;
}
th {
  text-align: left;
  padding: 10px;
}
.table-row-header, .table-row-header:hover{
  background-color:#EBEDEF;
  font-weight: bold;
  color: #383838;
}
.table-small-scroll-down {
  max-height: 360px;
}
.table-fullscreen-scroll-down {
  max-height: calc(100vh - 92px);
}
@media (min-width: 319px) and (max-width: 768px) {
  .table-wrapper {
    padding: 10px;
    padding-top: 0px;
  }
  .table-small-scroll-down {
    max-height: calc(68vh - 17px);
  }
  .table-fullscreen-scroll-down {
    max-height: calc(100vh - 115px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/TableChart.vue